import { computed, type Ref } from 'vue'
import scssVariables from '@/assets/scss/scssVariables'

import {
  STATUS_RESOURCE_REQUEST,
  type StatusResourceRequest,
  STATUS_RESOURCE_REQUEST_LOOKUP_LABEL,
} from '@/constants/persoplan'

import { lookup } from '@/utilities/misc'

export { type StatusResourceRequest, STATUS_RESOURCE_REQUEST }

interface Options {
  status: Ref<StatusResourceRequest | undefined | null>
}

const colors = {
  accept: scssVariables.color['status-resourceRequest-accept'],
  decline: scssVariables.color['status-resourceRequest-decline'],
} as const satisfies Partial<Record<StatusResourceRequest, string>>

export function useResourceRequestStatus(options: Options) {
  const classes = computed(() => {
    if (!options.status.value) return

    return {
      [`is-statusResourceRequest-${options.status.value}`]: true,
    }
  })

  const color = computed(() => {
    if (!options.status.value) return

    return colors[options.status.value]
  })

  const label = computed(() => {
    const result = lookup(
      options.status.value,
      STATUS_RESOURCE_REQUEST_LOOKUP_LABEL
    )

    if (!result) return 'Nicht beantwortet'
    return result
  })

  return {
    classes,
    color,
    label,
  }
}
